//import
import React, { useEffect, useState } from 'react';
import { Tag, Table, Space, Button, Pagination } from 'antd';
import { GetAllToolHistories } from '../../../api/AdminService';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import LoadingPage from '../../../Components/LoadingPage/LoadingPage';
import AdminAddToolHistory from './AdminAddToolHistory';
//item for account
const columns = [
    {
        title: 'Tool',
        dataIndex: 'tool',
        key: 'tool',
        render: (tool) => `${tool?.name}`,
    },
    {
        title: 'Borrow',
        dataIndex: 'numOfTool',
        key: 'numOfTool',
    },
    {
        title: 'create At',
        dataIndex: 'createAt',
        key: 'createAt',
        render: (createAt) => `${dayjs(createAt).format('DD-MM-YYYY')}`,
    },
    {
        title: 'User',
        dataIndex: 'borrower',
        key: 'borrower',
        render: (borrower) => `${borrower?.firstName} ${borrower?.lastName}`,
    },
    {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Link to={`/Admin/ToolHistory/${record.id}`}>Detail</Link>
            </Space>
        ),
    },
]
const AdminToolHistory = () => {
    const [loading, setLoading] = useState(true);
    const [dataSrc, setDataSrc] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState();
    const [Open, setOpen] = useState(false);

    const handleOk = () => {
        setOpen(true); 
    };

    const handleClose = () => {
        setOpen(false); 
    };
    const getTools = () => {
        try {
            GetAllToolHistories().then(res => {
                if (res.status === 200) {
                    console.log(res.data.data)
                    setDataSrc(res.data.data)
                    setTotalPage(res.data.pagination.totalRow)
                    setLoading(false)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getTools();
    }, []);

    return (
        <div
            style={{
                padding: 24,
                minHeight: '96.5vh',
                Width: '100vh',
            }}
        >
            <h1 style={{ fontSize: '2.5rem', marginBottom: 16, fontWeight: 'bold', textAlign: 'left', color: '#003366' }}>ALL TOOL HISTORY</h1>

            {loading ? (<LoadingPage />
            ) : (
                <>
                    <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                        <Button type="primary" onClick={handleOk}>
                            Borrow
                        </Button>
                        <Pagination
                            current={currentPage}
                            pageSize={12}
                            total={totalPage}
                            onChange={(page) => setCurrentPage(page)}
                            showSizeChanger={false}
                        />

                    </div>
                    <Table columns={columns} dataSource={dataSrc} pagination={false} />
                    {Open && (
                        <AdminAddToolHistory
                            open={Open}
                            onClose={handleClose}
                            onSuccess={getTools} // Call getTools on success to refresh the data
                        />
                    )}
                </>)}
        </div>
    );
};

export default AdminToolHistory;
